import httpService from 'stores/http-service';
import { DataManager } from 'utils/DataManager/dataManager';
import { DataState } from 'typings/enums';
import { IConversationDataManager } from 'typings/dataManagers';
import { timeout } from 'utils/timeoutUtils';

class ConversationDataManager extends DataManager implements IConversationDataManager {
    fileSizeUploadLimit: string;
    fileExtensions: string[];
    baseUrl: string = '';

    setBaseUrl(url: string): string {
        this.baseUrl = url;
        return this.baseUrl;
    }

    setFileVariables(fileExtensions: string[], fileSizeUploadLimit: string): void {
        this.fileExtensions = fileExtensions;
        this.fileSizeUploadLimit = fileSizeUploadLimit;
    }

    getConversationSummaries(
        masterAccountId: string,
        entityType: string,
        entityIds: string[]
    ): Promise<Nullable<IConversationSummary[]>> {
        const receive = () => this.getConversationSummariesWorker(
            masterAccountId,
            entityType,
            entityIds
        );

        const dataOptions = {
            getDataFunc: receive,
            blockUi: false,
            ignoreFailure: true
        };

        return timeout(this.getDataWithOptions<IConversationSummary[]>(dataOptions), 10000);
    }

    saveMessage(masterAccountId: string, entityType: string, entityId: string, message: IMessage):
        Promise<Nullable<number>> {
        const receive = () => this._postDataRequest<typeof message, number>(
            `${this.baseUrl}/api/accounts/${masterAccountId}/conversations/${entityType}/${entityId}/message`,
            message);
        return this.getData<number>(receive, true);
    }

    setDataState(state: DataState): void {
        this.protectedTransitionDataState(state);
    }

    private getConversationSummariesWorker(
        masterAccountId: string,
        entityType: string,
        entityIds: string[]
    ): Promise<IConversationSummary[]|null> {
        const url = `${this.baseUrl}/api/accounts/${masterAccountId}/conversations/${entityType}/summary`;
        return httpService.post<string[], IConversationSummary[]>(url, entityIds);
    }
}

export { ConversationDataManager };
export default ConversationDataManager;